export default "__VITE_ASSET__DfU25qAX__"